import {Component, EventEmitter, Input, OnInit, Output, SimpleChanges} from '@angular/core';
import {MatTableDataSource} from '@angular/material/table';
import {Router} from '@angular/router';
import { CmisService } from 'src/app/modules/services/cmis/cmis.service';
import {AppTranslateService} from 'src/app/modules/services/translate/app-translate.service';
import {environment} from 'src/environments/environment';

@Component({
    selector: 'app-news-table',
    templateUrl: './news-table.component.html',
    styleUrls: ['./news-table.component.css']
})
export class NewsTableComponent implements OnInit {

    @Input() list: any[] = [];

    @Output() sort = new EventEmitter<any>();

    public url = environment.server.hostSource;
    dataSource = new MatTableDataSource<any>();


    readColumns: String[] = [

        'title1',
        'title2',
        'title3',
        'moderNm',
        'modDt',
        'hitCnt',
        'action'


    ];

    displayedColumns = [
        'ptNewsId',
        'title1',

        'moderNm',
        'modDt',
        'hitCnt',
        'action'
    ];

    displayedColumnsAR = [
        'ptNewsId',
        'title2',
        'moderNm',
        'modDt',
        'hitCnt',
        'action'];
    displayedColumnsen = [
        'ptNewsId',
        'titleEn',

        'moderNm',
        'modDt',
        'hitCnt',
        'action'];
    img: string;

    constructor(
        private translate: AppTranslateService,
        private router: Router,
        private cmisService: CmisService,
    ) {


    }

    ngOnInit(): void {

        this.loadDataSource();


    }

    getlangue() {

        return this.translate.getDefaultLang() == 'ar';
    }

    getcol() {


        if (this.getlangue()) {
            return this.displayedColumnsAR;
        } else if (this.translate.getDefaultLang() == 'en') {
            return this.displayedColumnsen;
        } else {
            return this.displayedColumns;
        }
    }

    ngAfterViewInit(): void {

        this.loadDataSource();
    }

    loadDataSource() {
        this.dataSource.data = this.list;


        //     column='http://192.168.1.100:8077/ptNews/image'
        //   }
        //  });
    }

    ngOnChanges(changes: SimpleChanges): void {

        const {list} = changes;
        if (list.currentValue !== list.previousValue) {
            this.loadDataSource();
        }
    }

    onSortChange($event: any) {
        this.sort.emit({
            nameCol: $event.active as any,
            direction: ($event.direction.toUpperCase() || 'ASC') + ' nulls last',
        });
    }

    detailNews(news) {
        
        this.cmisService.updateHitCntProtail(news.ptNewsId)
            .subscribe(response => {
                this.router.navigate([
                    '/portail/news/details',
                    news.ptNewsId
                ]);
            });
      
    }


}
